const binarySearchProblems = [
  {
      title: "Binary Search",
      url: "https://leetcode.com/problems/binary-search/"
    },
    {
      title: "Find First and Last Position of Element",
      url: "https://leetcode.com/problems/find-first-and-last-position-of-element-in-sorted-array/"
    },
    {
      title: "Search in Rotated Sorted Array",
      url: "https://leetcode.com/problems/search-in-rotated-sorted-array/"
    },
    {
      title: "Find Minimum in Rotated Sorted Array",
      url: "https://leetcode.com/problems/find-minimum-in-rotated-sorted-array/"
    },
    {
      title: "Search a 2D Matrix II",
      url: "https://leetcode.com/problems/search-a-2d-matrix-ii/"
    }
];
export default binarySearchProblems;